var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-d-flex p-flex-column"},[_c('iframe',{ref:"angularIframe",staticClass:"p-d-flex",staticStyle:{"height":"90vh"},attrs:{"frameBorder":"0","src":"/ng/chemicals/bulk-import-global-status"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }